import { AuthAccountJobPositionAssignmentStatusChoices, GetJobSuggestionsQuery } from "@graphql/generated";

export type JobSuggestionResults = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<NonNullable<GetJobSuggestionsQuery["admin"]>["jobSuggestionResult"]>["edges"][number]
    >["node"]
  >["items"]
>["edges"];

export const addIsConfirmedToJobSuggestionResult = (jobSuggestionResult: JobSuggestionResults) => {
  return jobSuggestionResult.map((edge) => ({
    ...edge,
    node: {
      ...edge?.node,
      isConfirmed:
        edge?.node?.jobPositionAssignment?.status ===
        AuthAccountJobPositionAssignmentStatusChoices.AWAITING_JOBSEEKER_APPROVAL,
    },
  }));
};
